// src/modules/mapas/queries.js — V2-R.2 dados do Mapa
import { sb } from '../../api/supabaseClient.js';

const _ymd = (d) => d.toISOString().slice(0, 10);

export async function fetchMapaData(dataPontos) {
  const hoje = dataPontos || _ymd(new Date());
  const seteDiasAtras = _ymd(new Date(Date.now() - 7 * 86400000));

  const results = await Promise.allSettled([
    sb.from('obras')
      .select('id,nome,status,latitude,longitude,endereco,data_previsao_fim,valor_contrato,clientes(nome_razao_social),etapas_obra(progresso,peso,valor_etapa)')
      .not('latitude', 'is', null)
      .not('longitude', 'is', null),
    sb.from('obras')
      .select('id,nome,status')
      .is('latitude', null)
      .neq('status', 'concluida'),
    sb.from('ponto_registros')
      .select('id,entrada,saida,latitude_entrada,longitude_entrada,distancia_metros,obra_detectada,modo_registro,auto_fechado,funcionarios(nome,cargo)')
      .eq('data', hoje)
      .not('latitude_entrada', 'is', null)
      .order('entrada'),
    sb.from('registros_obra')
      .select('obra_id,data_registro')
      .gte('data_registro', seteDiasAtras),
  ]);

  const [obrasR, semCoordR, pontosR, rdosR] = results;
  return {
    obras: obrasR.status === 'fulfilled' ? (obrasR.value.data || []) : [],
    semCoord: semCoordR.status === 'fulfilled' ? (semCoordR.value.data || []) : [],
    pontos: pontosR.status === 'fulfilled' ? (pontosR.value.data || []) : [],
    rdos7d: rdosR.status === 'fulfilled' ? (rdosR.value.data || []) : [],
  };
}

export async function fetchPontosDoDia(dataYmd) {
  const { data } = await sb.from('ponto_registros')
    .select('id,entrada,saida,latitude_entrada,longitude_entrada,distancia_metros,obra_detectada,modo_registro,auto_fechado,funcionarios(nome,cargo)')
    .eq('data', dataYmd)
    .not('latitude_entrada', 'is', null)
    .order('entrada');
  return data || [];
}
